
export default [
    {
        path: '/',
        name: 'Welcome',
        component: () =>
            import("@/components/public/Welcome"),
    },
    {
        path: '/login',
        name: 'Login',
        component: () =>
            import("@/components/public/Login"),
    },
    {
        path: '/auth/azure/callback',
        name: 'AzureCallback',
        component: () =>
            import("@/components/public/AzureCallback"),
    },
    {
        path: '/consultancy',
        name: 'Consultancy',
        component: () =>
            import("@/components/public/Consultancy"),
    },
    {
        path: '/training',
        name: 'Training',
        component: () =>
            import("@/components/public/Training"),
    },
    {
        path: '/reset_password/:email/:code',
        name: 'ResetPassword',
        component: () =>
            import("@/components/public/ResetPassword"),
    },
    {
        path: '/welcome_password_change/:email/:code',
        name: 'WelcomePasswordChange',
        component: () =>
            import("@/components/public/WelcomePasswordChange"),
    },
    {
        path: '/solutions',
        name: 'SolutionsView',
        component: () =>
            import("@/components/new-page/SolutionsView"),
    },
    {
        path: '/about-us',
        name: 'AboutUsView',
        component: () =>
            import("@/components/new-page/AboutUsView"),
    },
    {
        path: '/institutions',
        name: 'InstitutionsView',
        component: () =>
            import("@/components/new-page/InstitutionsView"),
    },
    {
        path: '/training-view',
        name: 'TrainingView',
        component: () =>
            import("@/components/new-page/TrainingView"),
    },
    {
        path: '*',
        name: 'Page404',
        component: () =>
            import("@/components/public/Page404"),
    },
    {
        path: '/page-403',
        name: 'Page403',
        component: () =>
            import("@/components/public/Page403"),
    },
    {
        path: '/page-maintenance',
        name: 'PageMaintenance',
        component: () =>
            import("@/components/public/PageMaintenance"),
    },
]